import * as React from 'react';
import type { SliderSingleProps } from 'antd';
import { Slider } from 'antd';
import globalStyles from '@/styles/global.module.css';
import { extractRGB } from '../../../utils/rgbTorgba';
import merge from 'lodash-es/merge';

export const OpacitySlider: React.FC<SliderSingleProps & { color: string }> = ({
  color,
  className,
  style = {},
  styles = {},
  ...restProps
}) => {
  const rgb = extractRGB(color);

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const mergedStyle = merge(style, {
    '--slider-r': rgb?.r || 0,
    '--slider-g': rgb?.g || 0,
    '--slider-b': rgb?.b || 0,
    borderRadius: '5px',
    border: `1px solid ${color}`,
  } as React.CSSProperties);

  const mergedStyles = merge(styles, {
    track: {
      background: `transparent`,
      width: '10px',
    },
    handle: {
      top: '-1px',
    },
  });

  return (
    <Slider
      className={`${globalStyles.checker} ${className || ''}`}
      style={mergedStyle}
      styles={mergedStyles}
      {...restProps}
    />
  );
};
